import styled from 'styled-components';
import { Modal } from 'antd';

export const ModalStyled = styled(Modal)`
  .ant-modal-body {
    min-height: 130px;
  }
`;
